module.exports = __webpack_public_path__ + "img/cliRemover3.3d05e6f9.jpg";